import React, {Component} from "react";
import MitPeople from './mitPeople.component';
import {withTranslation} from "react-i18next";

const MIT_SOURCES = ["12", "13", 12, 13];

class MultipleIntervalTarget extends Component {
    constructor(props) {
        super(props);
        this.wizard_settings = (typeof props.kr_ui_wizard !== 'undefined' && props.kr_ui_wizard.length) ? props.kr_ui_wizard : false;
        this.state = {
            kpiType: this.props.krTypeMIT
        };
    }

    isEnabled = id => {
        if (!this.wizard_settings) {
            return false;
        }
        const button = this.wizard_settings.find(b => b.id == id);
        if (typeof button !== 'undefined' && button.hasOwnProperty('value')) {
            return button.value == 'true';
        }
        return false;
    };

    static getDerivedStateFromProps(props, state) {
        const {krTypeMIT} = props;
        let newState = {
            ...state,
          }
        if (krTypeMIT !== newState.kpiType) {
            newState.kpiType = krTypeMIT;
        }
        return newState;
    }

    render() {

        return (
            <div data-test='MultipleIntervalTarget'> {/* {kpiType === "person" && ( */}
                <MitPeople {...this.props}
                    kpiType={
                        this.state.kpiType
                    }
                    clickButtonEvent={
                        this.props.clickButtonEvent
                    }
                    isEnabled={
                        this.isEnabled
                    }
                    showRolErr={this.props.showRolErr}
                    /> {/* )} */}
                {/* {kpiType === "ds" && (
					<DataStreamComp
						isMit={true}
						{...this.props}
						kpiType={this.state.kpiType}
					/>
				)} */} </div>
        );
    }
}

export default withTranslation()(MultipleIntervalTarget);
